import {
  REMOVE_GROUP_PARTICIPANT,
  REMOVE_GROUP_PARTICIPANT_SUCCESS,
  REMOVE_GROUP_PARTICIPANT_CLEAN,
  REMOVE_GROUP_PARTICIPANT_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  groupParticipant: {},
}

const GroupParticipantRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_GROUP_PARTICIPANT:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_GROUP_PARTICIPANT_SUCCESS:
      state = {
        ...state,
        groupParticipant: action.payload.groupParticipant,
        loading: false,
        done: true,
      }
      break
    case REMOVE_GROUP_PARTICIPANT_CLEAN:
      state = initialState
      break
    case REMOVE_GROUP_PARTICIPANT_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupParticipantRemove
